export default __webpack_public_path__ + "static/media/1554.11051cb1.png";